import { render, staticRenderFns } from "./TasksGantt.vue?vue&type=template&id=a660d5ce&scoped=true&"
import script from "./TasksGantt.vue?vue&type=script&lang=js&"
export * from "./TasksGantt.vue?vue&type=script&lang=js&"
import style0 from "./TasksGantt.vue?vue&type=style&index=0&id=a660d5ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a660d5ce",
  null
  
)

export default component.exports